/*
 * @Author: liuxiaoling 
 * @Date: 2021-04-14 09:59:08 
 * @Last Modified by: liuxiaoling
 * @Last Modified time: 2021-04-25 10:35:19
 * @description: Page For qyweixin  
 */
/**
 * [内嵌页面]
 * 微信网页 wx_h5
 * 企业微信 wxwork_h5
 * 微信小程序 wxapp_h5
 * 钉钉 dingding_h5
 * APP app_h5
 */

import { getRequest } from '@/utils'
import * as dd from 'dingtalk-jsapi'

// 获取code值
export const getQywxCode = () => {
    const scope = 'snsapi_base'
    // const appid = 'ww55c671cf68173bc0'
    const appid = getRequest().CropID
    const href = location.href.replace(/(&?)appid=[^&]+/, '')
    const redirect_uri = encodeURIComponent(href)
    if (appid) {
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=STATE&connect_redirect=1#wechat_redirect`
    }
}

export const getDingCode = () => {
    const corpId = getRequest().CropID
    dd.ready (function () {
        dd.runtime.permission.requestAuthCode({
            corpId: corpId,
            onSuccess: function (result) {
                console.log(result)
                location.href = `${location.href}&code=${result.code}`
            },
            onFail : function (err) {
                console.log(err)
            }
        })
    })
}


export const getCode = (type) => {
    if (type === 'wxwork_h5') getQywxCode()
    if (type === 'dingding_h5') getDingCode()
}
